import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { RegExps } from '../resources/regexps.constant';

@Directive({
  selector: '[appNotStartZero]'
})
export class NotStartZeroDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event']) onInput(e: KeyboardEvent): void {
    const value = (e.target as HTMLInputElement).value;
    if (RegExps.NOT_START_WITH_ZERO.test(value)) {
      this.control.control.setValue((+value).toString());
    } else if (value === '0') {
      this.control.control.setValue('');
    }
  }
}
